import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseFlashFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7276 2.18192C15.8094 1.85487 15.6629 1.51346 15.3695 1.34737C15.0762 1.18127 14.7081 1.23131 14.4697 1.46969L2.46969 13.4697C2.25519 13.6842 2.19103 14.0068 2.30711 14.287C2.4232 14.5673 2.69668 14.75 3.00002 14.75H10.0394L8.27242 21.8181C8.19065 22.1452 8.33714 22.4866 8.6305 22.6527C8.92385 22.8188 9.29198 22.7687 9.53035 22.5303L21.5304 10.5303C21.7449 10.3158 21.809 9.99326 21.6929 9.71301C21.5768 9.43275 21.3034 9.25002 21 9.25002H13.9606L15.7276 2.18192Z"
        fill={color}
      />
    </svg>
  );
};
